import React from 'react';
import { motion } from 'framer-motion';
import { MOCK_CATEGORIES } from '../context/AppContext';
import { Header } from '../components/ui/Header';
import { SearchBar } from '../components/ui/SearchBar';
import { CategoryCard } from '../components/ui/CategoryCard';
export function CategoriesScreen() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-290">
      <Header title="All Categories" showBack={false} data-id="element-291" />

      <div className="p-4" data-id="element-292">
        <div className="mb-6" data-id="element-293">
          <SearchBar readOnly placeholder="Search categories..." data-id="element-294" />
        </div>

        <div className="grid grid-cols-3 gap-4" data-id="element-295">
          {MOCK_CATEGORIES.map(cat => <CategoryCard key={cat.id} category={cat} layout="grid" data-id="element-296" />)}
        </div>
      </div>
    </motion.div>;
}